import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useContext, useEffect, useState } from 'react';
import { addcontext } from '../ContextShare/ContextShare';

function AdminPagination({ count,refresh }) {
  const {paginationStartIndexAD,setPaginationStartIndexAD}=useContext(addcontext)
  const {paginationEndIndexAD,setPaginationEndIndexAD}=useContext(addcontext)
  const [totalCount, setTotalCount] = useState(count);
  const [start, setStart] = useState(1);
  const [end, setEnd] = useState(25);
  const [pageSize, setPageSize] = useState(25);
  const [response, setResponse] = useState(1);

  useEffect(() => {
    setPaginationStartIndexAD(start);
    setPaginationEndIndexAD(end);
  }, [response]);

  useEffect(()=>{
    setPaginationStartIndexAD(1)
    setPaginationEndIndexAD(25)
      setTotalCount(count)
    setEnd(25)
    setStart(1)
    setResponse(response+1)
  },[count,refresh])
  const handleEnd = () => {
    setStart(1);
    setEnd(pageSize);
    setResponse(response + 1);
  };

  const handleNext = () => {
    const newStart = start + pageSize;
    const newEnd = end + pageSize;
    if (newStart < totalCount) {
      setStart(newStart);
    }
    if (newEnd <= totalCount) {
      setEnd(newEnd);
    } else {
      setEnd(totalCount);
    }
    setResponse(response + 1);
  };

  const handlePrev = () => {
    const newStart = start - pageSize;
    const newEnd = start - 1;
    if (newStart > 0) {
      setStart(newStart);
      setEnd(newEnd);
    } else {
      setStart(1);
      setEnd(pageSize);
    }
    setResponse(response + 1);
  };

  const handleFinal = () => {
    const pages = Math.ceil(totalCount / pageSize);
    const newStart = (pages - 1) * pageSize + 1;
    const newEnd = totalCount;
    setStart(newStart);
    setEnd(newEnd);
    setResponse(response + 1);
  };

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
    setStart(1);
    setEnd(newSize);
    setResponse(response + 1);
  };

  return (
    <div className='flex flex-row w-full mb-5 mt-2 '>
      <div className='flex flex-row w-full gap-2 justify-end items-center me-4'>
        <div>
          <p className='md:text-sm text-xs text-gray-800'>Rows per page:</p>
        </div>
        <div className='md:text-sm text-xs text-gray-800 md:pr-2 '>
          <select id="options" name="options" className='bg-white' onChange={handlePageSizeChange} value={pageSize}>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="200">200</option>
            <option value="500">500</option>
          </select>
        </div>

        <div>
          <p className='md:text-sm text-xs text-gray-800'>{paginationStartIndexAD}-{paginationEndIndexAD} of {totalCount}</p>
        </div>

        <div className='flex flex-row md:gap-5 gap-1 text-gray-800'>
          <button onClick={handleEnd} className='p-1 bg-gray-200 hover:bg-gray-300 rounded-full'>
            <Icon icon="icon-park-outline:go-start" className='md:text-lg text-sm' />
          </button>
          <button onClick={handlePrev} className='p-1 bg-gray-200 hover:bg-gray-300 rounded-full'>
            <Icon icon="mingcute:left-line" className='md:text-lg text-sm' />
          </button>
          <button onClick={handleNext} className='p-1 bg-gray-200 hover:bg-gray-300 rounded-full'>
            <Icon icon="mingcute:right-line" className='md:text-lg text-sm' />
          </button>
          <button onClick={handleFinal} className='p-1 bg-gray-200 hover:bg-gray-300 rounded-full'>
            <Icon icon="icon-park-outline:go-end" className='md:text-lg text-sm' />
          </button>
        </div>
      </div>
    </div>
  );
}

export default AdminPagination;
